// Pure helpers for the Holding dashboard (/admin). Kept framework-free so the
// honest-metric logic from #69 can be unit-tested without a DOM harness.

// Maps the backend /health/ready status to a display label + StatTile accent.
export const HEALTH_DISPLAY = {
  ok: { label: "Bình thường", accent: "emerald" },
  degraded: { label: "Suy giảm", accent: "amber" },
  down: { label: "Lỗi kết nối", accent: "red" },
};

export function healthDisplay(status) {
  return HEALTH_DISPLAY[status] || null;
}

// /health/ready returns HTTP 503 with a JSON body when degraded; a missing
// response means the backend is unreachable, which is itself a real signal.
export function healthStatusFromError(err) {
  const status = err && err.response && err.response.data && err.response.data.status;
  return status || "down";
}

// "1/8 pháp nhân có ghi nhận" — never claim a holding-wide mean without coverage.
export function kpiCoverageLabel(companiesWithData, totalCompanies) {
  if (!totalCompanies) return "";
  return `${companiesWithData || 0}/${totalCompanies} pháp nhân có ghi nhận`;
}

export function hasAttendanceData(stats) {
  return Number((stats && stats.att_total) || 0) > 0;
}

export function hasKpiData(stats) {
  return Number((stats && stats.kpi_records) || 0) > 0;
}
